import React from "react";
import SVGIcon, { IconProps } from "ui/SVGIcon";

const path = "M12 7L-6.52533e-07 13.9282L-4.68497e-08 0.0717964L12 7Z";

export default function PlayIcon(props: IconProps) {
  return <SVGIcon path={path} color="ColorMint500" {...props} />;
}
